
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic16On as ObiHydraulic16OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-16-on.js';
 
 
 

 
 export const ObiHydraulic16On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-16-on',
   elementClass: ObiHydraulic16OnElement,
   events: {
     
   }
  });
 
 